import { Form, Modal, Button as AntButton, Radio } from 'antd';
import { Bars } from 'react-loader-spinner';
import { CommonFormProps } from '.';
import { analytics } from 'src/services/analytics';
import { logger } from 'src/services/logger';

const FORM_TYPE = 'SOAPP2';
type Props = CommonFormProps;

function SOAPP2Form({ isOpen, appointment, loading, onSave, form }: Props) {
  const [soapp2Form] = Form.useForm();

  const formData = form.content as {
    title: string;
    description: string;
    questions: { title: string; options: { value: number; label: string }[] }[];
  };

  const submit = async () => {
    try {
      analytics.track('Clicked Submit In SOAPP2 Form', {
        appointment_id: appointment.appointment_id,
      });
      const values = (await soapp2Form.validateFields()) as Record<
        string,
        number
      >;
      const score = Object.entries(values).reduce((acc, [key, value]) => {
        acc = acc + value;
        return acc;
      }, 0);

      const questions = formData.questions;
      const response = questions.map(({ title, options }) => ({
        title,
        score: values[title],
        selected_option: options.find(
          (option) => option.value == values[title]
        ),
      }));

      await onSave({
        form_type: FORM_TYPE,
        response: {
          response,
          score,
        },
      });
    } catch (e) {
      logger.error('Error submitting SOAPP2 form', {}, e as Error);
    }
  };

  if (!formData)
    return (
      <Modal open={isOpen} footer={null} closable centered>
        <div className="flex justify-center items-center h-full">
          <Bars
            height="25"
            width="25"
            color="#00D090"
            ariaLabel="bars-loading"
            wrapperStyle={{}}
            wrapperClass="pt-1 sm:pt-2"
            visible={true}
          />
        </div>
      </Modal>
    );

  const { questions } = formData;

  const formItems = questions.map(({ title, options }) => (
    <Form.Item
      key={title}
      name={title}
      label={<div className="text-md font-medium">{title}</div>}
      rules={[{ required: true, message: 'Please select an option' }]}
    >
      <Radio.Group
        options={options.map((option) => ({
          ...option,
          style: { display: 'flex' },
        }))}
      />
    </Form.Item>
  ));

  return (
    <Modal
      open={isOpen}
      title={
        <div>
          <div className="text-xl font-bold"></div>
        </div>
      }
      footer={
        <div className="flex justify-end">
          <AntButton
            className="ih-button-primary"
            onClick={submit}
            loading={loading}
          >
            Submit
          </AntButton>
        </div>
      }
      closable={false}
      centered
    >
      <div className="flex flex-col gap-4">
        <Form form={soapp2Form} layout="vertical">
          {formItems}
        </Form>
      </div>
    </Modal>
  );
}

export { SOAPP2Form };
